export default {
  root: {
    borderTop: `1px solid #eeeeee`,
    fontFamily: "proxima_nova_rgregular",
  }
};
